const MIN_DST_ID = 1
const MAX_DST_ID = 32

export const isFantasyPlayerIdDST = (fantasyPlayerId: number) => {
  return fantasyPlayerId >= MIN_DST_ID && fantasyPlayerId <= MAX_DST_ID
}
